import React from 'react';

import { AppBar, Drawer } from '@mui/material';
import { withStyles } from '@mui/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import Finalcad from 'components/SvgComponents/icons/Finalcad';
import BusinessOrganisation from 'containers/BusinessOrganisation';
import { selectLoggedUserData, selectSpecialRights } from 'containers/GlobalWrapper/selectors';
import AccountSettingsButton from 'containers/NavigationBar/components/AccountSettingsButton';
import HelpCenter from 'containers/NavigationBar/components/HelpCenter';
import KolimmoButton from 'containers/NavigationBar/components/KolimmoButton';
import SettingsButton from 'containers/NavigationBar/components/SettingsButton';
import SuperAdminLogo from 'containers/NavigationBar/components/SuperAdminLogo';
import SwitchThemeColorButton from 'containers/NavigationBar/components/SwitchThemeColorButton';
import { NAVBAR_HEIGHT } from 'containers/NavigationBar/constants';
import reducer from 'containers/NavigationBar/reducer';
import { authorizations } from 'utils/constants';
import injectReducer from 'utils/injectReducer';

export const styles = theme => ({
  drawer: {
    flexShrink: 0,
    height: NAVBAR_HEIGHT,
  },
  drawerPaper: {
    width: '100%',
    height: NAVBAR_HEIGHT,
    overflow: 'inherit',
    borderRight: 'none',
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    height: `${NAVBAR_HEIGHT}px`,
    backgroundColor: theme.palette.background.white,
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: `${theme.spacing(4)}`,
  },
  toolbarIconWrap: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  logo: {
    marginTop: '32px',
  },
});

function NavigationBar({ children, classes, className, history, specialRights, dataUser }) {
  let isAccountSettingsPage = path => {
    if (path === '/accountSettings') {
      return true;
    }
    return false;
  };

  isAccountSettingsPage = isAccountSettingsPage(history?.location?.pathname);

  const filteredPermisions = specialRights.filter(
    right =>
      right.action === authorizations.specialUser.readObservationFcLibrary ||
      right.action === authorizations.specialUser.writeObservationFcLibrary ||
      right.action === authorizations.specialUser.readFormFcLibrary ||
      right.action === authorizations.specialUser.writeFormFcLibrary ||
      right.action === authorizations.specialUser.readAdminPortal,
  );

  return (
    <Drawer
      className={classes.drawer}
      variant="permanent"
      classes={{
        paper: classes.drawerPaper,
      }}
      anchor="top"
    >
      <AppBar
        position="static"
        elevation={0}
        classes={{
          root: classNames({
            [classes.toolbar]: true,
            [className]: className,
          }),
        }}
      >
        <div>
          {isAccountSettingsPage ? <Finalcad className={classes.logo} /> : <BusinessOrganisation />}
        </div>
        <div className={`icons-toolbar ${classes.toolbarIconWrap}`}>
          {children}
          <KolimmoButton />
          {filteredPermisions.length > 0 && <SuperAdminLogo />}
          <HelpCenter />
          <SwitchThemeColorButton />
          <SettingsButton />
          <AccountSettingsButton dataUser={dataUser} />
        </div>
      </AppBar>
    </Drawer>
  );
}

NavigationBar.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
  dataUser: PropTypes.object,
  specialRights: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

const mapStateToProps = createStructuredSelector({
  specialRights: selectSpecialRights(),
  dataUser: selectLoggedUserData(),
});

const withConnect = connect(
  mapStateToProps,
  null,
);
const withReducer = injectReducer({ key: 'verticalNavBar', reducer });

export default compose(
  withReducer,
  withConnect,
  withRouter,
  withStyles(styles),
)(NavigationBar);
